import React, { useEffect, useState, FC } from 'react';
import { useHistory } from 'react-router-dom';
import XLSX from "xlsx";

//Components
import { Button, Container, Form } from 'react-bootstrap';
import ActivityLoading from '../common/ActivityLoading';
import ActivityToast from '../common/ActivityToast';

//Services
import { getGroups } from '../../services/GroupService';
import { createUsersProcess } from '../../services/UserService';

//Types
import { GroupInterface } from '../common/Types';

//Styles
import '../common/styles.scss';

interface ToastOptionsInterface {
    open: boolean;
    message: string;
}

const ImportUsers: FC = (props: any) => {
    const { location } = props;

    const [selectedGroup, setSelectedGroup] = useState<string>();
    const [userGroups, setUserGroups] = useState<Array<GroupInterface>>([]);
    const [users, setUsers] = useState<Array<any>>([]);
    const [toastOptions, setToastOptions] = useState<ToastOptionsInterface>({ open: false, message: "" });
    const [loading, setLoading] = useState(false);

    const history = useHistory();

    useEffect(() => {
        setLoading(true);
        fetchGroups();
    }, [])

    useEffect(() => {
        if (location.state?.group) {
            setSelectedGroup(location.state?.group);
        }
    }, [location])

    const fetchGroups = () => {
        getGroups().then((response: any) => {
            response?.sort((g1: any, g2: any) => g1.name.localeCompare(g2.name));
            setUserGroups(response as Array<GroupInterface>);
            setLoading(false);
        })
    }

    const handleOnSubmit = () => {
        setLoading(true);

        const usersPayload = users.map((usr) => {
            return {
                email: usr.email,
                displayName: `${usr.name}`,
                code: usr.code,
                providerId: "firebase",
                deleted: false
            }
        });

        createUsersProcess(usersPayload, selectedGroup).then((response: any) => {
            setLoading(false);

            setToastOptions({ open: true, message: response.message })
        });
    }

    function changeItemSelected(selected: string) {
        setSelectedGroup(selected);
    }

    const handleFileUpload = (file: any) => {
        const reader = new FileReader();
        const rABS = !!reader.readAsBinaryString;

        reader.onload = e => {
            const bstr = e?.target?.result;
            const wb = XLSX.read(bstr, { type: rABS ? "binary" : "array" });
            /* Get first worksheet */
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            /* Convert array of arrays */
            const rows: Array<any> = XLSX.utils.sheet_to_json(ws, { header: 1 });
            /* Update state */

            const usersToImport: Array<any> = [];
            if (rows?.length > 0) {
                const excelFields = ["name", "code", "email"];
                for (let index = 1; index < rows.length; index++) {
                    const row = rows[index];

                    let result: any = {};
                    excelFields.forEach((field, i) => {
                        result[field] = row[i]
                    });

                    usersToImport.push(result)
                }
            }

            setUsers(usersToImport);
        };

        if (rABS)
            reader.readAsBinaryString(file);
        else
            reader.readAsArrayBuffer(file);
    }

    const handleToastClose = (data: any) => {
        setToastOptions({ open: false, message: "" });
    }

    const handleGoBack = () => {
        if (location.state?.group) {
            history.push({ pathname: `/userGroup/edit/${location.state?.group}` });
        } else {
            history.goBack();
        }
    }

    if (loading)
        return <ActivityLoading />

    return (
        <Container>
            <div style={{ marginBottom: '10px' }}>
                <h1>Importar usuarios</h1>
            </div>
            <Button
                type="submit"
                variant="outline-primary"
                aria-label="save"
                className="return-button"
                onClick={() => handleGoBack()}
            >
                {`Regresar`}
            </Button>
            <ActivityToast {...toastOptions} onClose={handleToastClose} autohide={4000} />
            <div style={{ marginBottom: '10px', display: 'flex', flexDirection: 'row' }}>
                <p style={{ paddingRight: '5px' }}>Importar archivo. CSV.</p>
                <a href={"../alumnos.csv"} download="alumnos.csv" >Descargar plantilla.</a>
            </div>
            <Form.Group>
                <Form.Control
                    type="file"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    required
                    name="archivo"
                    onChange={(e: any) => handleFileUpload(e.target.files[0])}
                />
            </Form.Group>
            <Form.Group controlId="userGroup">
                <Form.Label>Grupo para todos los usuarios a importar</Form.Label>
                <select value={selectedGroup} name="userGroup" id="userGroup" className='select-input' onChange={(e: React.ChangeEvent<HTMLSelectElement>) => changeItemSelected(e.target.value)}>
                    <option value="">Selecciona un grupo...</option>
                    {userGroups.map((grp) =>
                        <option key={grp.id} value={grp.id}>{grp.name}</option>)}
                </select>
            </Form.Group>
            <div style={{ marginBottom: '10px', marginTop: '20px' }}>
                <Button variant="primary" onClick={handleOnSubmit}>
                    Importar
                </Button>
            </div>
        </Container>
    )
}
export default ImportUsers;